export function createFullName(name: string): string {
  return `OpenAudience > 1P > ${name}`;
}
